export function commonReject(error) {
  let errorObj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      if (data.errors[0]) {
        errorObj = new Error(data.errors[0].user_message);
      } else {
        errorObj = new Error(data.errors);
      }
    } else if (data.message) {
      errorObj = new Error(data.message);
    } else {
      errorObj = new Error(error.message);
    }
  } else {
    errorObj = new Error(error.message);
  }
  return Promise.reject(errorObj);
}

export function commonReject2(error) {
  let errorObj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      if (data.errors[0]) {
        errorObj = new Error(data.errors[0].user_message);
      } else {
        errorObj = new Error(data.errors);
      }
    } else if (data.message) {
      errorObj = new Error(data.message);
    } else {
      errorObj = new Error(error.message);
    }
    return Promise.reject(errorObj);
  }
}
